/* WildRoot Botanics — theme behaviour
   No dependencies. Everything degrades gracefully without JS. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------ money */

  var moneyFormat = (window.WR && window.WR.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = whole + '.' + parts[1];
    return moneyFormat
      .replace('{{amount}}', out)
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount_with_comma_separator}}', out.replace(/,/g, ' ').replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', whole.replace(/,/g, ' '));
  }

  /* ------------------------------------------------------- drawers/overlay */

  var overlay = $('[data-wr-overlay]');
  var openDrawer = null;

  function showOverlay(show) {
    if (!overlay) return;
    overlay.hidden = !show;
    document.body.style.overflow = show ? 'hidden' : '';
  }

  function toggleDrawer(drawer, open) {
    if (!drawer) return;
    if (open) {
      drawer.classList.add('is-open');
      openDrawer = drawer;
      showOverlay(true);
      var focusable = drawer.querySelector('button, a, input');
      if (focusable) focusable.focus();
    } else {
      drawer.classList.remove('is-open');
      openDrawer = null;
      showOverlay(false);
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-wr-drawer-open]');
    if (opener) {
      e.preventDefault();
      toggleDrawer($('#' + opener.getAttribute('data-wr-drawer-open')), true);
      return;
    }
    if (e.target.closest('[data-wr-drawer-close]')) {
      e.preventDefault();
      toggleDrawer(openDrawer, false);
    }
  });

  if (overlay) overlay.addEventListener('click', function () { toggleDrawer(openDrawer, false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) toggleDrawer(openDrawer, false);
  });

  /* ---------------------------------------------------------- countdown bar */

  $$('[data-wr-countdown]').forEach(function (el) {
    var hours = parseInt(el.getAttribute('data-wr-countdown'), 10) || 9;
    var key = 'wr-countdown-end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    var now = Date.now();
    if (!end || end < now) {
      end = now + hours * 3600 * 1000;
      try { sessionStorage.setItem(key, String(end)); } catch (err) {}
    }
    var hEl = $('[data-unit="h"]', el);
    var mEl = $('[data-unit="m"]', el);
    var sEl = $('[data-unit="s"]', el);
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var left = Math.max(0, end - Date.now());
      var total = Math.floor(left / 1000);
      if (hEl) hEl.textContent = pad(Math.floor(total / 3600));
      if (mEl) mEl.textContent = pad(Math.floor(total / 60) % 60);
      if (sEl) sEl.textContent = pad(total % 60);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* -------------------------------------------------------------- gallery */

  $$('[data-wr-gallery]').forEach(function (gallery) {
    var slides = $$('.wr-gallery__slide', gallery);
    var thumbs = $$('.wr-gallery__thumb', gallery);

    function select(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
    });
  });

  /* ------------------------------------------------------- variant picker */

  $$('[data-wr-buybox]').forEach(function (box) {
    var dataEl = document.querySelector('[data-wr-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!variants || !variants.length) return;

    var idInput = $('[data-wr-variant-id]', box);
    var atcButton = $('.wr-atc', box);
    var comparePrice = $('.wr-compare-price', box);
    var gallery = document.querySelector('[data-wr-gallery]');

    function selectedOptions() {
      return $$('.wr-option', box).map(function (opt) {
        var checked = opt.querySelector('[data-wr-option-value]:checked');
        return checked ? checked.value : null;
      });
    }

    function matchVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }

    function apply(variant) {
      if (!variant) {
        if (atcButton) {
          atcButton.disabled = true;
          atcButton.textContent = 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (atcButton) {
        atcButton.disabled = !variant.available;
        if (!variant.available) atcButton.textContent = 'Sold out';
      }

      if (comparePrice) {
        comparePrice.textContent = formatMoney(
          variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price
        );
      }

      /* tier prices are quantity × this variant's price, less the tier's
         discount — recomputed so switching variants keeps them honest */
      $$('.wr-tier', box).forEach(function (tier) {
        var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var pct = parseFloat(tier.getAttribute('data-discount')) || 0;
        var gross = variant.price * qty;
        var net = Math.round(gross * (100 - pct) / 100);
        tier.setAttribute('data-price-cents', net);
        var priceEl = $('.wr-tier__price', tier);
        var wasEl = $('.wr-tier__was', tier);
        if (priceEl) priceEl.textContent = formatMoney(net);
        if (wasEl) wasEl.textContent = formatMoney(gross);
        if (tier.classList.contains('is-selected')) tier.click();
      });

      /* jump the gallery to the image attached to this variant */
      if (gallery && variant.featured_media_position !== null) {
        var thumb = $$('.wr-gallery__thumb', gallery)[variant.featured_media_position];
        if (thumb) thumb.click();
      }

      /* keep the URL shareable */
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-wr-option-value]', box).forEach(function (input) {
      input.addEventListener('change', function () {
        var wrap = input.closest('.wr-option');
        var label = wrap && $('[data-wr-option-selected]', wrap);
        if (label) label.textContent = input.value;
        apply(matchVariant(selectedOptions()));
      });
    });
  });

  /* ---------------------------------------------------------- offer tiers */

  $$('[data-wr-buybox]').forEach(function (box) {
    var tiers = $$('.wr-tier', box);
    var atcPrice = $('[data-wr-atc-price]', box);
    var stickyPrice = document.querySelector('[data-wr-sticky-price]');
    var qtyInput = $('[data-wr-qty]', box);
    var propInputs = $('[data-wr-props]', box);

    function select(tier) {
      tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); });
      var radio = $('input[type="radio"]', tier);
      if (radio) radio.checked = true;

      var cents = parseInt(tier.getAttribute('data-price-cents'), 10) || 0;
      var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var label = tier.getAttribute('data-label') || '';

      if (qtyInput) qtyInput.value = qty;
      if (atcPrice) atcPrice.textContent = formatMoney(cents);
      if (stickyPrice) stickyPrice.textContent = formatMoney(cents);

      /* line-item properties so the offer is visible on the order */
      if (propInputs) {
        propInputs.innerHTML = '';
        var p = document.createElement('input');
        p.type = 'hidden';
        p.name = 'properties[_offer]';
        p.value = label;
        propInputs.appendChild(p);

        var perks = $$('.wr-tier__perk', tier).map(function (n) {
          return (n.getAttribute('data-perk') || n.textContent).trim();
        });
        if (perks.length) {
          var g = document.createElement('input');
          g.type = 'hidden';
          g.name = 'properties[_includes]';
          g.value = perks.join(', ');
          propInputs.appendChild(g);
        }
      }
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () { select(tier); });
      tier.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(tier); }
      });
    });

    /* No tier blocks at all — the merchant is running a bundle app (Kaching,
       Rebuy…) that owns the offer. Leave quantity at 1 and don't touch price. */
    if (!tiers.length) return;

    var preselected = tiers.filter(function (t) { return t.classList.contains('is-selected'); })[0];
    select(preselected || tiers[0]);
  });

  /* ------------------------------------------------------- sticky mobile ATC */

  var sticky = $('[data-wr-sticky]');
  var anchor = $('[data-wr-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
      });
    }, { threshold: 0 }).observe(anchor);
  }

  $$('[data-wr-sticky-submit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      /* Prefer whatever add-to-cart is actually on the page — a bundle app's
         button if it replaced ours, otherwise submit the product form. */
      var appBtn = document.querySelector('[data-wr-buybox] .wr-app-block button[type="submit"], [data-wr-buybox] .wr-app-block [name="add"]');
      if (appBtn) { appBtn.click(); return; }

      var ownBtn = $('[data-wr-buybox] .wr-atc');
      if (ownBtn) { ownBtn.click(); return; }

      var form = $('[data-wr-buybox] form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  /* ------------------------------------------------------------- cart qty */

  $$('[data-wr-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.wr-qty');
      var input = $('input', wrap);
      var step = parseInt(btn.getAttribute('data-wr-qty-step'), 10);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      input.value = next;
      var form = btn.closest('form');
      if (form) form.submit();
    });
  });

  /* ------------------------------------------------------ cart drawer qty */

  /* -/+ in the drawer used to post the line's form, and Shopify answers that with the /cart
     page. Change the line in the background instead and swap in a fresh drawer, so the shopper
     stays where they are with the drawer open. Capture phase on document: the per-button
     listeners above and the one pdp-main.js puts on the drawer never see these clicks. Any
     failure falls back to the post. */
  var CART_DRAWER = 'WrCartDrawer';
  var routesRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function cartDrawerSource() {
    /* every storefront page renders the drawer (it's in the layout); /cart is the lightest.
       Carry a theme preview along so drafts show their own drawer. */
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    return routesRoot + 'cart' + (preview ? '?preview_theme_id=' + encodeURIComponent(preview) : '');
  }

  function refreshCartDrawer() {
    return fetch(cartDrawerSource(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart drawer: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var freshDrawer = fresh.getElementById(CART_DRAWER);
        var drawer = document.getElementById(CART_DRAWER);
        if (!freshDrawer || !drawer) throw new Error('cart drawer: not in the page');
        drawer.innerHTML = freshDrawer.innerHTML;

        var opener = '[data-wr-drawer-open="' + CART_DRAWER + '"]';
        var freshCount = fresh.querySelector(opener + ' .wr-cart-count');
        $$(opener).forEach(function (el) {
          var count = $('.wr-cart-count', el);
          if (!freshCount) {
            if (count && count.parentNode) count.parentNode.removeChild(count);
            return;
          }
          if (!count) {
            count = document.createElement('span');
            count.className = 'wr-cart-count';
            el.appendChild(count);
          }
          count.textContent = freshCount.textContent;
        });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wr-qty-step]');
    var drawer = btn && btn.closest('#' + CART_DRAWER);
    var form = drawer && btn.closest('form');
    if (!form || !window.fetch || !window.DOMParser) return;
    /* on the cart page the page reloads anyway; let the post happen there */
    if (document.querySelector('[name="updates[]"]')) return;
    e.preventDefault();
    e.stopPropagation();
    if (drawer.getAttribute('aria-busy') === 'true') return;

    var key = form.getAttribute('data-wr-line-key');
    var step = parseInt(btn.getAttribute('data-wr-qty-step'), 10) || 0;
    var row = btn.closest('.wr-cart-item');
    drawer.setAttribute('aria-busy', 'true');
    if (row) row.style.opacity = '.5';

    /* read the real quantity from the cart, not the box: the box can be stale */
    fetch(routesRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var item = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!item) return; /* already gone: just show the cart as it is now */
        return fetch(routesRoot + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, item.quantity + step) })
        }).then(function (response) {
          if (!response.ok) throw new Error('cart change: ' + response.status);
        });
      })
      .then(refreshCartDrawer)
      .then(function () { drawer.removeAttribute('aria-busy'); })
      .catch(function () {
        var input = $('input[name="quantity"]', form);
        if (input) input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        HTMLFormElement.prototype.submit.call(form);
      });
  }, true);

  /* Back from checkout can show a page from the browser's cache with an out-of-date drawer */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && document.getElementById(CART_DRAWER) && window.fetch && window.DOMParser) {
      refreshCartDrawer().catch(function () {});
    }
  });

  /* ------------------------------------------------ continue shopping */

  /* "Continue shopping" (empty cart, drawer and /cart page) goes back to the product page the
     shopper landed on from the ad, old or new PDP alike, rather than the all-products list.
     Remembered: the first product page of a visit, or any product page opened from an ad link.
     Its href is the fallback (new PDP) for anyone who never opened one. Already on that page:
     just close the drawer. */
  var LANDING_PDP = 'wr-landing-pdp';
  var LANDING_SEEN = 'wr-landing-pdp-visit';
  var FROM_AD = /[?&](fbclid|gclid|ttclid|utm_source|utm_medium|utm_campaign)=/i;

  function pdpPath(loc) {
    /* keep only what picks the page: ?view=pdp (new PDP) and a theme preview */
    var params = new URLSearchParams(loc.search);
    var keep = new URLSearchParams();
    ['view', 'preview_theme_id'].forEach(function (k) {
      if (params.get(k)) keep.set(k, params.get(k));
    });
    var query = keep.toString();
    return loc.pathname + (query ? '?' + query : '');
  }

  function storage(kind) {
    try { return window[kind]; } catch (err) { return null; }
  }

  if (/\/products\/[^/]+\/?$/.test(window.location.pathname)) {
    var local = storage('localStorage');
    var session = storage('sessionStorage');
    try {
      if (local && (FROM_AD.test(window.location.search) || !(session && session.getItem(LANDING_SEEN)))) {
        local.setItem(LANDING_PDP, pdpPath(window.location));
      }
      if (session) session.setItem(LANDING_SEEN, '1');
    } catch (err) { /* private mode: keep the fallback link */ }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-wr-continue]');
    if (!link) return;
    var local = storage('localStorage');
    var landing = null;
    try { landing = local && local.getItem(LANDING_PDP); } catch (err) { landing = null; }
    var target = landing || link.getAttribute('href');
    if (target === pdpPath(window.location) && openDrawer) {
      e.preventDefault();
      toggleDrawer(openDrawer, false);
      return;
    }
    if (landing) {
      e.preventDefault();
      window.location.href = landing;
    }
  });

  /* ------------------------------------------------ bundle app selection */

  /* Kaching Bundles deselects a deal bar when it's clicked again and falls back to the
     first bar ("Buy 1 Kit"). Swallow presses on the bar that's already selected, before
     Kaching sees them, so a second tap keeps the shopper's choice. Links inside the bar
     (the free-gift link) still work. */
  function onSelectedBundleBar(target) {
    var bar = target.closest && target.closest('.kaching-bundles__bar');
    if (!bar || !bar.classList.contains('kaching-bundles__bar--selected')) return false;
    return !target.closest('a');
  }

  document.addEventListener('click', function (e) {
    if (!onSelectedBundleBar(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && onSelectedBundleBar(e.target)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
